import { useState, useEffect } from 'react';

export interface ResponsiveBreakpoints {
  isMobile: boolean;
  isTablet: boolean;
  isLaptop: boolean;
  isDesktop: boolean;
  isLargeDesktop: boolean;
  screenSize: 'mobile' | 'tablet' | 'laptop' | 'desktop' | 'large-desktop';
  containerPadding: string;
  gridCols: number;
  touchTarget: boolean;
}

export const useResponsiveLayout = (): ResponsiveBreakpoints => {
  const [breakpoints, setBreakpoints] = useState<ResponsiveBreakpoints>({
    isMobile: false,
    isTablet: false,
    isLaptop: false,
    isDesktop: false,
    isLargeDesktop: false,
    screenSize: 'desktop',
    containerPadding: 'px-6',
    gridCols: 4,
    touchTarget: false,
  });

  useEffect(() => {
    const updateBreakpoints = () => {
      const width = window.innerWidth;
      
      const isMobile = width < 768;
      const isTablet = width >= 768 && width < 1024;
      const isLaptop = width >= 1024 && width < 1280;
      const isDesktop = width >= 1280 && width < 1536;
      const isLargeDesktop = width >= 1536;

      let screenSize: ResponsiveBreakpoints['screenSize'] = 'desktop';
      let containerPadding = 'px-6';
      let gridCols = 4;

      if (isMobile) {
        screenSize = 'mobile';
        containerPadding = 'px-4';
        gridCols = 1;
      } else if (isTablet) {
        screenSize = 'tablet';
        containerPadding = 'px-6';
        gridCols = 2;
      } else if (isLaptop) {
        screenSize = 'laptop';
        containerPadding = 'px-8';
        gridCols = 3;
      } else if (isLargeDesktop) {
        screenSize = 'large-desktop';
        containerPadding = 'px-12';
        gridCols = 4;
      }

      const touchTarget = isMobile || isTablet;

      setBreakpoints({
        isMobile,
        isTablet,
        isLaptop,
        isDesktop,
        isLargeDesktop,
        screenSize,
        containerPadding,
        gridCols,
        touchTarget,
      });
    };

    updateBreakpoints();
    
    window.addEventListener('resize', updateBreakpoints);
    return () => window.removeEventListener('resize', updateBreakpoints);
  }, []);

  return breakpoints;
};